<template>
    <div>
        <div class="sign-in-view">
            <b-button
                class="sign-in-view--google-button"
                icon-left="google"
                test-id="google-button"
                @click="goToLogin"
            >
                <span class="sign-in-view--google-button-text">Sign in with Google</span>
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SignInView',
    methods: {
        goToLogin() {
            window.location.assign(process.env.VUE_APP_LOGIN_BASE_URL);
        },
    },
};
</script>

<style lang="scss">
.sign-in-view {
    margin-top: 160px;
    justify-content: center;
    display: flex;

    .sign-in-view--google-button {
        height: 40px;
        width: 300px;
    }

    .sign-in-view--google-button-text {
        font-weight: bold;
        text-align: left;
    }

    .mdi-google::after {
        content: url(assets/google.svg);
        position: absolute;
        top: 10px;
        left: 7px;
    }
}
</style>
